export default {
  TH: {
   InvoiceTitle: 'ขอใบกำกับภาษีอิเล็กทรอนิกส์',
    ReceiptNoTitle : 'เลขที่ใบเสร็จรับเงิน / หมายเลขคำสั่งซื้อ',
    ReceiptNoTitlePlaceHolder : 'เลขที่ใบเสร็จรับเงิน / หมายเลขคำสั่งซื้อ (1)',
    StoreNoTitle : 'เลขสาขา',
    StoreNoTitlePlaceHolder : 'เลขสาขา 5 หลัก (2)',
    EnterYourEmailTitle : 'กรอกอีเมลเพื่อรับรหัสผ่าน OTP',
    TextReceiptNoTitle : 'เลขที่ใบเสร็จรับเงิน',
    EmailTitle: 'E-mail',
    EmailTitlePlaceHolder: 'E-mail',
    EmailDetailTitle: '*** แนะนำให้ใช้บริการ Email Providers ส่วนตัว เช่น Gmail, Outlook, Yahoo, Hotmail เพื่อป้องกันการ Block อีเมลในการส่ง E-Tax Invoice',


    TaxIDPlaceHolder :'เลขบัตรประจำตัวประชาชน / ผู้เสียภาษีอากร',
    TaxIDType2PlaceHolder :'เลขประจำตัวผู้เสียภาษี',
    OtpVerificationTitle: 'ยืนยัน OTP',
    OtpVerificationTitlePlaceHolder: 'OTP',
    OtpVerificationDetailTitle: 'กรอกรหัส 6 หลัก ที่ส่งไปที่อีเมลของคุณ',
       
    InvoiceReceiptRequest: 'ขอใบกำกับภาษีอิเล็กทรอนิกส์',
    InvoiceStoreNo: 'เลขสาขา',
    InvoiceReceiptNo: 'เลขที่ใบเสร็จรับเงิน',
    InvoicePersonType1: 'บุคคลทั่วไป',
    InvoicePersonType2: 'นิติบุคคล',
 /// PersonTyp2
    InvoiceBranchCode: 'เลขที่สาขา',
    InvoiceFullName: 'ชื่อ-นามสกุล สำหรับออกใบเสร็จรับเงิน',
    InvoiceFirstName: 'ชื่อ',
    InvoiceFirstNameType2: 'บริษัท',
    
    InvoiceSurname: 'นามสกุล',
    placeholderFirstName: 'ชื่อ',
    placeholderFirstNameType2: 'บริษัท',
    placeholderSurname: 'นามสกุล',
    
    InvoiceTaxID: 'เลขบัตรประจำตัวประชาชน / ผู้เสียภาษีอากร',
    InvoiceTaxIDType2: 'เลขประจำตัวผู้เสียภาษี',
    InvoiceCountry: 'ประเทศ',
    InvoicePostCode: 'รหัสไปรษณีย์ 5 หลัก',
    InvoicePostCodePrv: 'รหัสไปรษณีย์',
     InvoicePostCodePrvType2: 'รหัสไปรษณีย์ 5 หลัก',
    
    InvoiceType2Address1: 'ที่อยู่ตามทะเบียนบริษัท 1',
    InvoiceType2Address2: 'ที่อยู่ตามทะเบียนบริษัท 2',
    
    InvoiceAddress1: 'ที่อยู่ตามบัตรประชาชน 1',
    InvoiceAddress2: 'ที่อยู่ตามบัตรประชาชน 2',
    InvoiceMobilePhone: 'เบอร์โทรศัพท์มือถือ 10 หลัก',
    InvoiceMobilePhonePrv: 'เบอร์โทรศัพท์มือถือ',
    InvoiceMobilePhonePrvType2: 'เบอร์โทรศัพท์',
    InvoiceMobilePhoneType2: 'หมายเลขโทรศัพท์',
    InvoiceTermAndCordition: '<a style="font-weight:400"> ฉันได้อ่านและยอมรับ </a> <a href="https://pacifica.co.th/privacy-policy/" target="_blank"> ข้อกำหนดและเงื่อนไข </a> <a style="font-weight:400"> ที่เกี่ยวข้องแล้ว</a>',
    InvoiceTermAndCorditionNotice: 'ทางบริษัทขอสงวนไม่รับออกใบกำกับภาษีหรือแก้ไขย้อนหลังทุกกรณี',


    // PageConfirmBFSend // Preview
    InvoicePreview: 'ตรวจสอบข้อมูลใบกำกับภาษีอิเล็กทรอนิกส์',
    InvoicePreviewReceiptNo: 'เลขที่ใบเสร็จรับเงิน',
    InvoicePreviewStoreNo: 'เลขสาขา',
    InvoicePreviewETaxInformation: 'ข้อมูลการขอใบกำกับภาษีอิเล็กทรอนิกส์',
    InvoicePreviewPersonType: 'ประเภท',

    //// Purchase Detail
    PurchaseDetails: 'รายการสินค้า',
    PurchaseDetailsItem: 'รายการ',
    PurchaseDetailsQTY: 'จำนวน',
    PurchaseDetailsAmount: 'ราคา',
    PurchaseDetailsTotal: 'รวม',
    PurchaseDetailsReIssue: 'ทางบริษัทขอสงวนไม่รับออกใบกำกับภาษีหรือแก้ไขย้อนหลังทุกกรณี',

    Request: 'การขอใบกำกับภาษีอิเล็กทรอนิกส์ของคุณ',
    InvoiceTitleSubmission: 'การขอใบกำกับภาษีอิเล็กทรอนิกส์ของคุณ',
    TitlRequesteStutusComplete: 'เสร็จสมบูรณ์',
    TitlRequesteStutusFaild: '****Error*****',
    TitlRequesteReceiptNo: 'เลขที่ใบเสร็จรับเงิน ',
    TitlRequesteStoreNo: 'เลขสาขา',


    ButtonSubmit: 'ยืนยัน',
    ButtonEdit: 'แก้ไข',
    ButtonClear: 'ล้างข้อมูล',
    ButtonSend: 'ส่งข้อมูล',
    ButtonComfirm: 'ยืนยัน',
    ButtonNext: 'ถัดไป',
    ButtonSendOTP: 'ขอ OTP',
    ButtonReSendOTP: 'ส่ง OTP อีกครั้ง',
    ButtonNewRequest: 'ส่งใบเสร็จเพิ่ม',
    ButtonClose: 'ปิด',

    
    FaildModalOtpError:'รหัส OTP ของคุณไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
    FaildModalIconCase1 :'Faild',
    FaildModalTitleCase1 :'ขออภัย เกิดข้อผิดพลาด',

    FaildModalReasonCase1:'เลขสาขาของคุณไม่ถูกต้อง <br> กรุณาตรวจสอบอีกครั้ง ',
    FaildModalReasonCase2:'ใบเสร็จรับเงิน / หมายเลขคำสั่งซื้อไม่ถูกต้อง <br> กรุณาตรวจสอบอีกครั้ง ',
    FaildModalReasonCase3:'ใบเสร็จรับเงิน / หมายเลขคำสั่งซื้อ / เลขสาขาของคุณไม่ถูกต้อง <br> กรุณาตรวจสอบอีกครั้ง ',
    //FaildModalReasonCase4:'มีคำขอสำหรับใบเสร็จรับเงิน / ใบคำสั่งซื้อนี้แล้ว (เลขINV)',
    FaildModalReasonCase4: 'มีคำขอสำหรับใบเสร็จรับเงิน / ใบคำสั่งซื้อนี้แล้ว <br>({inv})',
    FaildModalReasonCase4_2:'หากมีข้อสงสัยกรุณาติดต่อร้านค้า',

    FaildModalReasonCase6:'การขอออกใบกำกับภาษีแบบเต็มรูปแบบอิเล็กทรอนิกส์ต้องดำเนินการขอและกรอกข้อมูลครบถ้วนภายใน 3 วันนับจากวันที่ได้ชำระค่าสินค้า/ได้รับสินค้า',
    FaildModalReasonCase5:'การขอออกใบกำกับภาษีแบบเต็มรูปแบบอิเล็กทรอนิกส์ต้องดำเนินการขอและกรอกข้อมูลครบถ้วนภายใน 10 วันนับจากวันที่ได้ชำระค่าสินค้า/ได้รับสินค้า',
    FaildModalReasonCase7:'ยอดรายการสั่งซื้อไม่ถึง 2,000 ',

    FaildModalReasonCase10:'ใบเสร็จรับเงิน / หมายเลขคำสั่งซื้อ / เลขสาขาของคุณไม่ถูกต้อง <br> กรุณาตรวจสอบอีกครั้ง ',


    ValidationRequiredReceiptNo: 'กรุณากรอกเลขที่ใบเสร็จรับเงิน',
    ValidationRequiredStoreNo: 'กรุณากรอกเลขสาขา',
    ValidationRequiredBranchCode :'กรุณากรอกหมายเลขให้ครบ 5 หลัก',
    ValidationInvalidBranchCode :'กรุณากรอกหมายเลขให้ครบ 5 หลัก',
    ValidationRequiredFullName: 'กรุณากรอกชื่อ สำหรับออกใบเสร็จรับเงิน',
    ValidationRequiredFullNameType2: 'กรุณากรอกชื่อบริษัท สำหรับออกใบเสร็จรับเงิน',
    ValidationRequiredSurName: 'กรุณากรอกนามสกุล สำหรับออกใบเสร็จรับเงิน',
    ValidationRequiredTaxID: 'กรุณากรอกหมายเลขให้ครบ 13 หลัก',
    ValidationRequiredTaxIDType2: 'กรุณากรอกหมายเลขให้ครบ 13 หลัก',
    ValidationRequiredPostCode: 'กรุณากรอกรหัสไปรษณีย์ ให้ครบ 5 หลัก',
    ValidationRequiredAddress1: 'กรุณากรอกที่อยู่ตามบัตรประชาชน 1',
    ValidationRequiredAddress1Type2: 'กรุณากรอกที่อยู่ตามทะเบียนบริษัท 1',
    ValidationRequiredPhone: 'กรุณากรอกหมายเลขให้ครบ 10 หลัก',
    ValidationRequiredPhoneType2: 'กรุณากรอกหมายเลขโทรศัพท์ ',

    ErrorTitle: "ข้อผิดพลาด",
    ErrorFullName: "กรุณาตรวจสอบชื่อและนามสกุล",
    ErrorTaxID: "เลขประจำตัวผู้เสียภาษีต้องเป็นตัวเลข 13 หลัก",
    ErrorBranchNo: "รหัสสาขาต้องไม่เกิน 5 ตัวอักษร",
    ErrorEmail: "รูปแบบอีเมลไม่ถูกต้อง",
    ErrorPhone: "เบอร์โทรศัพท์มือถือต้องไม่เกิน 10 หลัก",
    ErrorPhoneType2: "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง (9–15 หลัก)",
    ErrorPostCode: "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก",
    ErrorAddress1: "ที่อยู่ตามบัตรประชาชน (1) ต้องไม่เกิน 256 ตัวอักษร",
    ErrorAddress2: "ที่อยู่ตามบัตรประชาชน (2) ต้องไม่เกิน 256 ตัวอักษร",
    ErrorDefault: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
     
  },
  EN: {
    InvoiceTitle: 'E-Tax Invoice Request',
    InvoiceTitleSubmission: 'E-Tax Invoice Request',
    ReceiptNoTitle : 'Receipt No. / Order No.',
    ReceiptNoTitlePlaceHolder : 'Receipt No. / Order No. (1)',
    StoreNoTitle : 'Store No.',
    StoreNoTitlePlaceHolder : '5 digit Store No. (2)',
    EnterYourEmailTitle : 'Enter your email to receive OTP',
    TextReceiptNoTitle : 'Receipt No.',
    EmailTitle: 'E-mail',
    EmailTitlePlaceHolder: 'E-mail',
    EmailDetailTitle: '*** We recommend using reputable personal email providers such as Gmail, Outlook, Yahoo, and Hotmail, to ensure e-tax invoices are delivered to your in-box without any blocking.',

    OtpVerificationTitle: 'OTP Verification',
     OtpVerificationTitlePlaceHolder: 'OTP',
    OtpVerificationDetailTitle: 'Enter the 6-digit code sent to your email.',
       
    InvoiceReceiptRequest: 'E-Tax Invoice Receipt Request',
    InvoiceStoreNo: 'Store No',
    InvoiceReceiptNo: 'Receipt No.',
    InvoicePersonType1: 'Individual',
    InvoicePersonType2: 'Legal Entity',
 /// PersonTyp2
    InvoiceBranchCode: 'Branch Code',
    InvoiceFullName: 'Full Name for E-Tax Invoice',
    
    InvoiceFirstName: 'Name ',

    InvoiceFirstNameType2: 'Company',
    InvoiceSurname: 'Surname ',
    placeholderFirstName: 'Name',
    placeholderFirstNameType2: 'Company',
    placeholderSurname: 'Surname',
    TaxIDPlaceHolder :'ID Card / Tax ID',
    TaxIDType2PlaceHolder :'Tax ID',
    InvoiceTaxID: 'ID Card / Tax ID',
    InvoiceTaxIDType2: 'Tax ID',
    InvoiceCountry: 'Country',
    InvoicePostCode: '5-digit Postcode',
    InvoicePostCodePrv: '5-digit Postcode',
    InvoicePostCodePrvType2: '5-digit Postcode',
    InvoiceAddress1: 'Registered Address 1',
    InvoiceAddress2: 'Registered Address 2',

    InvoiceType2Address1: 'Registered Company Address 1',
    InvoiceType2Address2: 'Registered Company Address 2',

    InvoiceMobilePhone: '10-digit Mobile No.',
    InvoiceMobilePhonePrv: '10-digit Mobile No.',
     InvoiceMobilePhonePrvType2: 'Phone No.',
    InvoiceMobilePhoneType2: 'Phone No.',
   // InvoiceTermAndCordition: 'I have read and agree to the applicable Terms & Condition',
   InvoiceTermAndCordition: '<a style="font-weight:400"> I have read and agreed to the applicable </a> <a href="https://pacifica.co.th/privacy-policy/" target="_blank"> Terms & Condition </a>',
    InvoiceTermAndCorditionNotice: 'The company reserves the right not to re-issue tax invoices or make retroactive corrections in any case.',


    // PageConfirmBFSend // Preview
    InvoicePreview: 'Verify E-Tax Invoice Request',
    InvoicePreviewReceiptNo: 'Receipt No',
    InvoicePreviewStoreNo: 'Store No',
    InvoicePreviewETaxInformation: 'E-Tax Invoice Request Information',
    InvoicePreviewPersonType: 'Type',

    //// Purchase Detail
    PurchaseDetails: 'Purchase Details',
    PurchaseDetailsItem: 'Item',
    PurchaseDetailsQTY: 'Quantity',
    PurchaseDetailsAmount: 'Price',
     PurchaseDetailsTotal: 'Total',
    PurchaseDetailsReIssue: 'The company reserves the right not to re-issue tax invoices or make retroactive corrections in any case.',

    Request: 'E-Tax Invoice Request',
    TitlRequesteStutusComplete: 'Completed',
    TitlRequesteStutusFaild: '****Error*****',
    TitlRequesteReceiptNo: 'Receipt No',
    TitlRequesteStoreNo: 'Store No.',


    ButtonSubmit: 'Submit',
    ButtonEdit: 'Edit',
    ButtonClear: 'Clear',
    ButtonSend: 'Submit',
    ButtonComfirm: 'Confirm',
    ButtonNext: 'Next',
    ButtonSendOTP: 'Request OTP',
    ButtonReSendOTP: 'Re-send OTP',
    ButtonNewRequest: 'New Request',
    ButtonClose: 'Close',


     FaildModalOtpError:'Please recheck and retry your OTP again',

    FaildModalIconCase1 :'Faild',
    FaildModalTitleCase1 :'Error',

    FaildModalReasonCase1:'Your Store number is incorrect. <br> Please check again.',
    FaildModalReasonCase2:'Your Receipt/Order number is incorrect.<br> Please check again.',
    FaildModalReasonCase3:'Your Receipt/Order number/Store number is incorrect.  <br> Please check again. ',
    // FaildModalReasonCase4:'There'+'s'+ ' already a request for this Receipt / Order No. ({inv})',
    FaildModalReasonCase4: "There's already a request for this Receipt / Order No. ({inv})",

    FaildModalReasonCase4_2:'If you have any question please contact the stores',

    FaildModalReasonCase6:'Electronic Full Tax Invoice should be requested with complete details within 3 days of purchasing/receiving',
    FaildModalReasonCase5:'Electronic Full Tax Invoice should be requested with complete details within 10 days of purchasing/receiving',
    FaildModalReasonCase7:'The total order amount does not meet the minimum requirement of 2,000. ',

    FaildModalReasonCase10:'Your Receipt/Order number/Store number is incorrect.  <br> Please check again. ',
    ValidationRequiredBranchCode :'Please enter a complete 5-digit number.',
    ValidationInvalidBranchCode :'Please enter a complete 5-digit number.',
    ValidationRequiredReceiptNo: 'Please enter receipt number',
    ValidationRequiredStoreNo: 'Please enter store number',

    ValidationRequiredFullName: 'Please enter a complete FirstName.',
    ValidationRequiredFullNameType2: 'Please enter a complete company name. ',
    ValidationRequiredSurName: 'Please enter a complete Surname.',
    ValidationRequiredTaxID: 'Please enter a complete 13-digit number.',
    ValidationRequiredTaxIDType2: 'Please enter a complete 13-digit number.',
    ValidationRequiredPostCode: 'Please enter a complete 5-digit postcode.',
    ValidationRequiredAddress1: 'Please enter the address as per your ID card 1',
    ValidationRequiredAddress1Type2: 'Please enter the address as per registered company address.',

    ValidationRequiredPhone: 'Please enter a complete 10-digit number.',
    ValidationRequiredPhoneType2: 'Please enter a complete phone number.',
    ErrorTitle: "Error",
    ErrorFullName: "Please check your First Or Last Name",
    ErrorTaxID: "Tax ID must be 13 digits",
    ErrorBranchNo: "Branch number must be 5 digits",
    ErrorEmail: "Invalid email format",
    ErrorPhone: "Phone number must be 10 digits",
    ErrorPhoneType2: "Please enter a valid phone number (9–15 digits)",
    ErrorPostCode: "Postcode must be 5 digits",
    ErrorAddress1: "Address (1) must not exceed 256 characters",
    ErrorAddress2: "Address (2) must not exceed 256 characters",
    ErrorDefault: "An error occurred. Please try again"
  }
}
